<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品编辑-基础信息
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--基本信息-->
    <div class="common-form">基本信息</div>
    <el-form-item label="商品名称：" :rules="[{ required: true, message: '请填写商品名称' }]" prop="model.product_name">
      <el-input v-model="form.model.product_name" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品编码："><el-input v-model="form.model.product_no" class="max-w460"></el-input></el-form-item>
    <el-form-item label="所属分类：" :rules="[{ required: true, message: '你选择商品分类' }]" prop="model.category_id">
      <el-select v-model="form.model.category_id"  multiple >
        <template v-for="cat in form.catgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="商品标签：" v-auth="'/product/label/index'">
      <el-select v-model="form.model.label_id" multiple filterable placeholder="请选择">
        <el-option
          v-for="item in form.label"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="商品属性：">
      <el-checkbox v-model="form.model.is_recommend">推荐</el-checkbox>
      <el-checkbox v-model="form.model.is_hot">热卖</el-checkbox>
      <el-checkbox v-model="form.model.is_new">新品</el-checkbox>
    </el-form-item>
    <el-form-item label="商品图片：" :rules="[{ required: true, message: '请上传商品图片' }]" prop="model.image">
      <div slot="label">商品图片：<gm-tips content="建议尺寸750x750" /></div>
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.model.image">
          <transition-group>
            <div class="item" v-for="(item, index) in form.model.image" :key="item.file_path">
              <img v-img-url="item.file_path" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>

    <el-form-item label="视频封面图：" prop="poster">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload({ type: 'poster' })">选择图片
        </el-button>
        <div class="draggable-list">
          <div v-if="form.model.poster !== ''" class="img item">
            <img :src="form.model.poster" width="100" height="100" alt="poster"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImgPoster"><i class="el-icon-close"></i></a>
          </div>
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="视频：" prop="video">
      <el-input type="text" v-model="form.model.video" placeholder="请选择视频" class="max-w460">
        <template slot="append">
          <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
          </el-button>
        </template>
      </el-input>
    </el-form-item>

    <el-form-item label="商品卖点：">
      <el-input type="textarea" v-model="form.model.selling_point" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="升级的等级：" prop="model.up_grade_id">
      <el-select v-model="form.model.up_grade_id" clearable>
        <el-option v-for="item in form.gradeList" :value="item.grade_id" :key="item.name" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="升级单数累计：">
      <el-radio-group v-model="form.model.is_grade_goods">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
      <div class="gray">选择是，下单后将参与用户升级累计</div>
    </el-form-item> -->
    <el-form-item label="单次限购数量：">
      <el-input type="number" min="0" v-model="form.model.buy_limit_num" class="max-w460" style="width:200px">
        <template slot="append">件 (默认0为不限)</template>
      </el-input>
    </el-form-item>
    
    
    <el-form-item label="是否开启最低购买限制：">
      <el-radio-group v-model="form.model.open_min_buy">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否按倍数购买：" v-if="form.model.open_min_buy==1">
      <el-radio-group v-model="form.model.is_multiple">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
      <div class="gray9">开启后，购买此商品以倍数下单</div>
    </el-form-item>
    <el-form-item label="最低下单数量设置:"  v-if="form.model.open_min_buy==1">
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="等级">
          </el-table-column>
          <el-table-column prop="name" label="最低下单数量">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.buy_total_set" type="number" placeholder="请输入下单数量"></el-input>
                <span class="ml10">件</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>

    <el-form-item label="累计限购数量：">
      <el-input  type="number" min="0"  v-model="form.model.buy_total_num" class="max-w460" style="width:200px">
        <template slot="append">件 (默认0为不限)</template>
      </el-input>
    </el-form-item>
    <el-form-item v-auth="'/supplier'" label="所属供货商：" prop="model.supplier_id">
      <el-select v-model="form.model.supplier_id" clearable>
        <el-option v-for="item in form.supplierList" :value="item.supplier_id" :key="item.company_name" :label="item.company_name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item v-auth="'/supplier'" label="平台抽佣比例：">
      <el-input v-model="form.model.platform_commission" class="max-w460" style="width:200px">
        <template slot="append">%</template>
      </el-input>
    </el-form-item>

    <div class="common-form"  v-auth="'/product/skucate/index'">属性分类</div>
    <el-form-item v-for="(item,index) in form.skucate" :key="index" :label="`${item.name}:`" v-auth="'/product/skucate/index'">
      <el-select v-model="form.model.skucate[item.id]" multiple clearable  placeholder="请选择">
        <el-option
          v-for="it in item.child"
          :key="it.id"
          :label="it.name"
          :value="it.id">
        </el-option>
      </el-select>
    </el-form-item>


    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 50 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片
    </Upload>
    <!--上传视频组件-->
    <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频
    </Upload>
  </div>
</template>

<script>

import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      isVideoUpload: false,
      isupload: false,
    };
  },
  inject: ['form'],
  created() {

  },
  methods: {

    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.image.concat(e);
        this.$set(this.form.model, 'image', imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.image.splice(index, 1);
    },
    /*上传封面图*/
    openUpload(e) {
      if (e.type === "poster") {
        this.isupload = true;
      } else {
        this.avatarUpload = true;
      }
    },
    /* 打开视频 */
    openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.model.video = e[0].file_path;
      }
      this.isVideoUpload = false;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.model.poster = e[0].file_path;
      }
      this.isupload = false;
    },
    /* 删除封面 */
    deleteImgPoster() {
      this.form.model.poster = "";
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Basic.vue